import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

import UpdateAutopayCCModal from "components/ModalDialogs/UpdateAutopayCCModal";
import config from "config/config";
import Badge from "components/General/Badge";
import moment from "moment";
export default function AutoPaymentCard({
  data,
  policies,
  isUpdated,
  setIsUpdated,
}) {
  const { t } = useTranslation();
  const [selectedPolicies, setSelectedPolicies] = useState([]);
  const [modalState, setModalState] = useState(false);
  const [expireSoon, setExpireSoon] = useState(false);
  const [statusText, setStatusText] = useState();
  useEffect(() => {
    setStatusText(data?.cardStatus);
    if (data && policies) {
      setSelectedPolicies(
        policies?.filter(
          (p) => p?.creditCard?.recurringReferenceId === data?.paymentProfileId
        )
      );
    }
    if (data?.cardStatus?.toLowerCase() !== "expired") {
      let firstdateExpireDate = moment(
        `${data?.expDate?.substring(0, 2)}/01/${data?.expDate?.substring(3)}`
      ).format("MM/DD/YYYY");
      let firstDateOfCurrentMonth = `${
        moment().month() + 1
      }/01/${moment().year()}`; // moment Month starts from 0 for jan
      if (
        (moment(firstdateExpireDate).diff(firstDateOfCurrentMonth, "months") ===
          parseInt(config.CREDIT_CARD_EXPIRE_CHECK) ||
          moment().diff(moment(firstdateExpireDate), "months") === 0) &&
        moment().year() === moment(firstdateExpireDate).year()
      ) {
        setStatusText(
          t("CustomerManagePayment-manage-payment-card-expired-soon")
        );
        setExpireSoon(true);
      } else if (
        moment().month() > moment(firstdateExpireDate).month() &&
        moment().year() === moment(firstdateExpireDate).year()
      ) {
        setStatusText(t("CustomerManagePayment-manage-payment-card-expired"));
        setExpireSoon(false);
      } else {
        setStatusText(t("CustomerManagePayment-manage-payment-card-valid"));
        setExpireSoon(false);
      }
    } else {
      setStatusText(t("CustomerManagePayment-manage-payment-card-expired"));
      setExpireSoon(false);
    }
  }, [data, policies, isUpdated]);
  const getCardStatus = (data) => {
    switch (data?.cardStatus?.toLowerCase()) {
      case "expired":
        return "problem";
      default: {
        if (expireSoon) return "risk";
        else return "good";
      }
    }
  };
  return (
    <>
      <div key={`payment`} className="ui-card p-4 md:p-6">
        <div className="ui-card-grid-layout">
          <div className="ui-paymethod-grid-title">
            <div className="text-lg font-semibold">
              {data?.type} {data?.isDefault ? "- Default" : ""}
            </div>
            <div className="text-sm font-semibold">{data?.accountNumber}</div>
          </div>
          <div className="ui-paymethod-grid-badge justify-self-end text-right">
            <Badge
              mediaSwitch={false}
              status={getCardStatus(data)}
              statusText={statusText}
              srPrefix=""
            />
          </div>
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t("CustomerManagePayment-manage-payment-card-cardholder-name")}
            </div>
            <div className="text-sm text-theme-text-secondary font-semibold">
              {data?.ownerName}
            </div>
          </div>
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t("CustomerManagePayment-manage-payment-card-expiration-date")}
            </div>
            <div
              className={`text-sm text-theme-text-secondary font-semibold ${
                data?.cardStatus?.toLowerCase() === "expired"
                  ? "text-ui-red"
                  : ""
              }`}
            >
              {data?.expDate}
            </div>
          </div>
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t(
                "CustomerManagePayment-manage-payment-card-delete-auto-pay-card-type"
              )}
            </div>
            <div className="text-sm text-theme-text-secondary font-semibold uppercase">
              {data?.cardType?.toUpperCase() === "MC"
                ? "MASTERCARD"
                : data?.cardType}
            </div>
          </div>
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t(
                "CustomerManagePayment-manage-payment-card-add-payment-methd-autopay-policy"
              )}
            </div>
            <div className="text-sm text-theme-text-secondary font-semibold">
              {selectedPolicies?.length > 0
                ? selectedPolicies[0]?.oldPolicy
                : ""}
            </div>
          </div>
          <div className="ui-paymethod-grid-actions place-self-end text-right">
            <button
              className="ui-btn-primary ui-btn-min-w ml-2"
              onClick={() => {
                setModalState(true);
              }}
            >
              {t(
                "CustomerManagePayment-manage-payment-card-add-payment-methd-view-update"
              )}
              <span className="sr-only">
                {" "}
                View or Update Credit Card - {data?.accountNumber}
              </span>
            </button>
          </div>
        </div>
      </div>
      <UpdateAutopayCCModal
        modalState={modalState}
        setModalState={setModalState}
        data={data}
        selectedPolicy={policies}
        isUpdated={isUpdated}
        setIsUpdated={setIsUpdated}
      />
    </>
  );
}
